'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('react-dom/client');
var framerMotion = require('framer-motion');
var styleInject_es = require('../style-inject.es-9d2f5f4e.js');
var Icon = require('../Icon-405a216c.js');
var Button = require('../Button-7698424c.js');
var Typography = require('../Typography-fd6f932a.js');
require('@jobber/design');
require('classnames');
require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css_248z = ".FVK4VwhLaVQ- {\n  position: relative;\n  z-index: 1003;\n  z-index: var(--elevation-toast);\n}\n\n.MUXYGaC7Msg- {\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  right: 0;\n  bottom: calc(16px * 1.5);\n  bottom: var(--space-large);\n  left: 0;\n  z-index: 1003;\n  z-index: var(--elevation-toast);\n  width: 100%;\n  box-sizing: border-box;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 calc(16px * 1.5);\n  padding: 0 var(--space-large);\n  color: rgba(255, 255, 255, 1);\n  color: var(--color-text--reverse);\n  font-size: calc(16px * 1);\n  font-size: var(--typography--fontSize-large);\n  pointer-events: none;\n}\n\n.yCRa7jHH33M- {\n  box-shadow: 0px calc(16px * 1) calc(16px * 1) 0px\n      rgba(0, 0, 0, 0.075),\n    0px 0px calc(16px / 2) 0px rgba(0, 0, 0, 0.05);\n  box-shadow: var(--shadow-high);\n  overflow: hidden;\n  pointer-events: all;\n}\n\n.yCRa7jHH33M- + .yCRa7jHH33M- {\n  margin-top: calc(16px * 1);\n  margin-top: var(--space-base);\n}\n\n.KiJL-VNZ3Sg- {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: calc((16px / 2) / 1.25) calc(16px * 1);\n  padding: calc(calc(16px / 2) / 1.25) calc(16px * 1);\n  padding: calc(var(--space-small) / 1.25) var(--space-base);\n  border-radius: calc(16px / 8);\n  border-radius: var(--radius-base);\n  background: rgb(1, 41, 57);\n  background: var(--color-surface--reverse);\n}\n\n.xtRB59TMHcU- {\n  margin-right: calc(16px * 1);\n  margin-right: var(--space-base);\n}\n\n.cExoS0APILs- {\n  margin-left: calc(16px * 1);\n  margin-left: var(--space-base);\n}\n\n.-T38wWbQUNs- {\n  margin-left: calc(16px / 2);\n  margin-left: var(--space-small);\n}\n";
var styles = {"wrapper":"FVK4VwhLaVQ-","container":"MUXYGaC7Msg-","toast":"yCRa7jHH33M-","slice":"KiJL-VNZ3Sg-","icon":"xtRB59TMHcU-","button":"cExoS0APILs-","action":"-T38wWbQUNs-"};
styleInject_es.styleInject(css_248z);

function Toast({ message, variation = "success", action, actionLabel, }) {
    const [visible, setVisible] = React.useState(true);
    const icon = getIcon();
    let timer;
    React.useEffect(() => startTimer(), []);
    return (React__default["default"].createElement(framerMotion.AnimatePresence, null, visible && (React__default["default"].createElement(framerMotion.motion.div, { className: styles.toast, initial: { opacity: 0, scale: 0.8 }, animate: { opacity: 1, scale: 1 }, onMouseEnter: () => stopTimer(), onMouseLeave: () => startTimer(), exit: {
            opacity: 0,
            scale: 0.8,
            height: 0,
            transition: { duration: 0.4 },
        } },
        React__default["default"].createElement("div", { className: styles.slice },
            React__default["default"].createElement("div", { className: styles.icon },
                React__default["default"].createElement(Icon.Icon, { color: icon.color, name: icon.name })),
            React__default["default"].createElement(Typography.Typography, { element: "span", size: "large" }, message),
            action && (React__default["default"].createElement(Button.Button, { label: `${actionLabel}`, onClick: action, type: "tertiary" })),
            React__default["default"].createElement("div", { className: styles.button },
                React__default["default"].createElement(Button.Button, { icon: "remove", ariaLabel: "Hide Notification", onClick: handleToastClose, type: "tertiary", variation: "subtle" })))))));
    function startTimer() {
        timer = setTimeout(() => handleToastClose(), getTimeout());
    }
    function stopTimer() {
        clearTimeout(timer);
    }
    function handleToastClose() {
        setVisible(false);
    }
    function getTimeout() {
        const min = 5000;
        const max = 10000;
        const time = message.length * 200;
        if (time < min)
            return min;
        if (time > max)
            return max;
        return time;
    }
    function getIcon() {
        switch (variation) {
            case "info":
                return { name: "knot", color: "lightBlue" };
            case "error":
                return { name: "alert", color: "red" };
            default:
                return { name: "checkmark", color: "green" };
        }
    }
}

const targetId = "atlantis-toast-element";
let target = document.querySelector(`#${targetId}`);
if (!target) {
    target = document.createElement("div");
    target.id = targetId;
    target.classList.add(styles.wrapper);
    document.body.appendChild(target);
}
const root = client.createRoot(target);
function showToast(props) {
    // Ensure target and body is still there when rendering the toast. This is due
    // to an issue with ReactDOM createRoot assuming document is always there and
    // Jest taking the document down.
    if (document.body.contains(target)) {
        root.render(React__default["default"].createElement(ToasterOven, Object.assign({}, props)));
    }
}
const ToastContainer = React.forwardRef(ToastInternal);
function ToasterOven(props) {
    const toastRef = React.useRef();
    React.useEffect(() => toastRef.current.add(props));
    return React__default["default"].createElement(ToastContainer, { ref: toastRef });
}
function ToastInternal(_, ref) {
    const [toastKey, setToastKey] = React.useState(0);
    const [toasts, setToasts] = React.useState([]);
    React.useImperativeHandle(ref, () => ({
        add: props => {
            setToastKey(toastKey + 1);
            setToasts([
                Object.assign(Object.assign({}, props), { id: toastKey }),
                ...toasts,
            ]);
        },
    }));
    return (React__default["default"].createElement("div", { className: styles.container }, toasts.map(toast => (React__default["default"].createElement(Toast, Object.assign({}, toast, { key: toast.id }))))));
}

exports.showToast = showToast;
